/*
 *   Copyright (c) 2023 RCUBE PLANET PVT LTD
 *   All rights reserved.
 *   @author Rishabh Goyal <contact@urishabh.com>
 */
// @ts-nocheck
/**
 * Auto Generated Routes of the project
 */

/**
 * Adonis Typings
 */
type MultipartFileContract = any

type ModelPaginatorContract<T extends any> = {
  meta: {
    total: number
    per_page: number
    current_page: number
    last_page: number
    first_page: number
    first_page_url: string | null
    last_page_url: string | null
    next_page_url: string | null
    previous_page_url: null
  }
  data: T[]
}

type DateTime = string

/**
 * Common Types (Related to controllers/routes/models)
 */
export enum BillTypeEnum {
  p2a = 'p2a',
  p2p = 'p2p',
}
export enum BillTypeEnum {
  p2p = 'p2p',
  p2a = 'p2a',
}
export enum BillStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}
export enum CreditNoteStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}
export type ExpoPushComposeType = Omit<ExpoPushMessage, 'to'> & { to?: ExpoPushMessage['to'] }
export type EmailComposeType = {
  from?: string
  to: EmailId
  subject: string
  htmlView?: {
    template: string
    data: Object
  }
  textView?: {
    template: string
    data: Object
  }
}
export enum NotificationStatusEnum {
  none = 'none', //default status
  dispatched = 'dispatched',
  processing = 'processing',
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}
export enum StatusEnum {
  processing = 'processing',
  none = 'none',
  success = 'success',
  failed = 'failed',
  pending = 'pending',
  dispatched = 'dispatched',
  review = 'review',
}

export enum BillTypeEnum {
  p2a = 'p2a',
  p2p = 'p2p',
}

export enum BillStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}

export enum BillTypeEnum {
  p2p = 'p2p',
  p2a = 'p2a',
}

export enum CreditNoteStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}

export enum BookPromotionalEnum {
  discount = 'discount', //for p2a
}

export enum NotificationStatusEnum {
  none = 'none', //default status
  dispatched = 'dispatched',
  processing = 'processing',
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}
export interface orderPGStatType {
  is_computed: true | false
  isPaid: boolean
  actualAmount: number
  paidAmount: number
  payableAmount: number
  pendingOrderItemsCount: number
  actions: {
    hold_amount: number
    is_withdrawable: boolean
    can_process_order: boolean
  }
}
export type xoxoDayError400 = {
  code: 400
  data: undefined
  errorId: 'PLE10001' | 'PLE10033' | 'PLE10003' | 'PLE10002' | 'PLE10032'
  errorInfo: string
  error: string
}
export type xoxoDayError401 = {
  code: 401
  data: undefined
  errorId?: 'PIPE10013' | 'PLE10019'
  errorInfo?: string
  error?: string
}
export type xoxoDayError403 = {
  code: 403
  data: undefined
  errorId: 'PLE10015'
  errorInfo: string
  error: string
}
export type xoxoDayError404 = {
  code: 404
  data: undefined
  errorId: 'PLE10021' | 'PLE10017' | 'PLE10029' | 'PLE10018' | 'PLE10016' | 'PLE10027'
  errorInfo: string
  error: string
}
export type xoxoDayError422 = {
  code: 422
  data: undefined
  errorId: 'PLE10012'
  errorInfo: string
  error: string
}
export type xoxoDayError409 = {
  code: 409
  data: undefined
  errorId: 'PLE10041'
  errorInfo: string
  error: string
}
export type xoxoDayError502 = {
  code: 502
  data: undefined
  errorId: 'PLE10020' | 'PLE10024' | 'PLE10034' | 'PLE10023' | 'PLE10025'
  errorInfo: string
  error: string[]
}
export type xoxoDayError500 = {
  // Internal server error
  code: 500
  data: undefined
  error: string
}

/**
 * Model Types
 */

export interface ApiLogin {
  id: number
  response: {
    code: number
    token: { type: string; token: string; expires_at: string }
    staff: {
      id: number
      email: string
      mobile: string
      name: string
      role: string
      remember_me_token: string
      is_active: number
      pin: number
      created_at: string
      updated_at: string
    }
  }
  created_at: DateTime
  updated_at: DateTime
}

export interface CallsUnit {
  id: number
  enable_quantity: boolean
  name: string
  created_at: DateTime
  updated_at: DateTime
}

export interface Category {
  id: number
  source: 'manual' | 'CouponFetcher' | 'Cbs'
  source_key: string
  can_auto_update: boolean
  parent_id: number | null
  name: string
  image: string | null
  description: string
  is_active: boolean
  is_popular: boolean
  is_on_top: boolean
  is_featured: boolean
  is_trending: boolean
  is_frequently_used: boolean
  store_count: number
  coupon_count: number
  created_at: DateTime
  updated_at: DateTime
  $parent_category_meta?: Category | null
  $sub_category_links?: Category[] | null
  $store_category_links?: StoreCategoryLink[] | null
}

export interface Circle {
  id: number
  name: string
  code: string
  long_code: string
  code_31662: string
  gst_state: string
  gst_code: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
  plans?: Plan[] | null
  $operator_circle_links?: OperatorCircleLink[] | null
}

export interface StoreReview {
  id: number
  store_id: number
  user_id: number
  rating: 1 | 2 | 3 | 4 | 5
  comment: string
  is_visible: boolean
  created_at: DateTime
  updated_at: DateTime
  $store_meta?: Store | null
}

export interface StoreReviewLike {
  id: number
  store_review_id: number
  user_id: number
  is_liked: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface Country {
  id: number
  code: string
  name: string
  created_at: DateTime
  updated_at: DateTime
}

export interface DataUnit {
  id: number
  enable_quantity: boolean
  does_renew_everyday: boolean
  name: string
  created_at: DateTime
  updated_at: DateTime
}

export interface Coupon {
  id: number
  store_id: number
  source: 'manual' | 'CouponFetcher' | 'Cbs'
  source_key: string
  can_auto_update: boolean
  last_updated: DateTime | null
  website_domain: string
  site_url: string | null
  coupon_code: string | null
  is_coupon: boolean
  title: string
  is_upto: boolean
  value: number | null
  is_percentage: boolean
  value_type: 'off' | 'cashback' | undefined
  validity: string
  validity_date: DateTime | null
  description: string | null
  details: string[]
  is_active: boolean
  is_verified: boolean
  success_rate: number | null
  is_popular: boolean
  is_best: boolean
  is_featured: boolean
  is_trending: boolean
  is_high_cashback_store: boolean
  is_frequently_used: boolean
  is_deal_of_the_day: boolean
  is_new: boolean
  is_on_top: boolean
  is_for_existing_user: boolean
  should_show_verified_time: boolean
  verified_at: DateTime | null
  slug: string | null
  priority: number
  created_at: DateTime
  updated_at: DateTime
  $store_meta?: Store | null
  $campaign_meta?: Campaign | null
  $coupon_category_links?: CouponCategoryLink[] | null
  $coupon_tag_links?: CouponTagLink[] | null
  $coupon_bank_links?: CouponBankLink[] | null
}

export interface CouponBankLink {
  id: number
  coupon_id: number
  bank_id: number
  created_at: DateTime
  updated_at: DateTime
  $bank_meta?: Bank | null
}

export interface CouponCategoryLink {
  id: number
  coupon_id: number
  category_id: number
  created_at: DateTime
  updated_at: DateTime
  $coupon_offer_meta?: Coupon | null
  $category_meta?: Category | null
}

export interface CouponComment {
  id: number
  comment: string
  coupon_id: number
  parent_id: number | null
  user_id: number
  is_visible: boolean
  created_at: DateTime
  updated_at: DateTime
  $coupon_meta?: Coupon | null
}

export interface CouponLike {
  id: number
  coupon_id: number
  user_id: number
  is_liked: boolean | null
  comment: string | null
  created_at: DateTime
  updated_at: DateTime
  $coupon_offer_meta?: Coupon | null
}

export interface CouponTagLink {
  id: number
  coupon_id: number
  tag_id: number
  created_at: DateTime
  updated_at: DateTime
  $coupon_meta?: Coupon | null
  $tag_meta?: Tag | null
}

export interface Banner {
  id: number
  store_id: number | null
  image: string
  label: string
  is_active: boolean
  priority: number
  createdAt: DateTime
  updatedAt: DateTime
  $store_meta?: Store | null
}

export interface Report {
  id: number
  user_id: number
  type: 'store_review' | 'coupon_comment'
  store_review_id: number | null
  coupon_comment_id: number | null
  description: string | null
  is_resolved: boolean
  created_at: DateTime
  updated_at: DateTime
  $coupon_comment_meta?: CouponComment | null
  $store_review_meta?: StoreReview | null
}

export interface Operator {
  id: number
  hsn_code: string | null
  sac_code: string | null
  duplicate_of: number | null
  tax_description_name: string
  biller_name: string
  biller_public_name: string
  biller_private_name: string
  category_name: string
  biller_state_name: string | undefined
  biller_state_code: string | undefined
  rapdrp_non_rapdrp: string | undefined
  partial_pay: string
  min_amount: number
  max_amount: number
  customer_surcharge: string
  customer_bill_updation: string
  due_date: string
  number: string
  length_number: string
  number_regex: string
  number_regex_example: string
  account: string
  length_account: string
  account_regex: string
  account_example: string
  authenticator3: string
  length_authenticator3: string
  authenticator3_regex: string
  authenticator3_example: string
  authenticator4: string
  length_authenticator4: string
  authenticator4_regex: string
  authenticator4_example: string
  authenticator5: string
  length_authenticator5: string
  authenticator5_regex: string
  authenticator5_example: string
  number_remarks: string
  is_active: boolean
  undefined: any
  is_working: boolean
  is_visible: boolean
  payu_biller_id: string | null
  is_bbps: boolean | null
  created_at: DateTime
  updated_at: DateTime
  $duplicate_operator_meta?: Operator | null
  $biller_meta?: Biller | null
}

export interface StaticAirline {
  id: number
  airline_id: number
  name: string
  alias: string
  iata: string
  icao: string
  callsign: string
  country: string
  active: string
  is_popular: boolean
  created_at: DateTime
  updated_at: DateTime
  contact_details:
    | {
        country_code: string | undefined
        contact_number: string
      }[]
    | null
}

export interface StaticAirport {
  id: number
  airport_id: number
  name: string
  city: string
  city_code: string
  location: string | null
  country: string
  country_code: string
  iata: string | null
  icao: string | null
  latitude: number | null
  longitude: number | null
  altitude: number | null
  timezone: string | null
  daylight_saving_time: string | null
  dz_database_time: string | null
  type: string | null
  source: string
  is_popular: boolean
  origin_route_count: number
  destination_route_count: number
  created_at: DateTime
  updated_at: DateTime
}
export interface OperatorCircleLink {
  id: number
  operator_id: number
  circle_id: number
  created_at: DateTime
  updated_at: DateTime
  $circle_meta?: Circle | null
}

export interface Bank {
  id: number
  source: 'manual' | 'CouponFetcher' | 'Cbs'
  source_key: string
  can_auto_update: boolean
  name: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface Plan {
  id: number
  operator_id: number
  amount: number
  validity_quantity: number | null
  validity_unit_id: number | null
  data_quantity: string | null
  data_unit_id: number | null
  data_extra_quantity: string | null
  data_extra_unit_id: number | null
  data_night_quantity: string | null
  data_night_unit_id: number | null
  sms_quantity: string | null
  sms_unit_id: number | null
  calls_quantity: string | null
  calls_unit_id: number | null
  description: string
  remarks: string | null | undefined
  talktime_quantity: number | null
  talktime_unit_id: number | null
  is_active: boolean
  sms_doesRenewEveryday: boolean
  data_doesRenewEveryday: boolean
  data_extra_doesRenewEveryday: boolean
  data_night_doesRenewEveryday: boolean
  is_prime: boolean
  is_quick_suggestion: boolean
  price_per_day: number | null
  created_at: DateTime
  updated_at: DateTime
  deleted_at: DateTime | null
  $operator_meta?: Operator | null
  $plans_circle_links?: PlansCircleLink[] | null
  $plan_category_links?: PlanCategoryLinking[] | null
  $validity_unit_meta?: ValidityUnit | null
  $talktime_unit_meta?: TalktimeUnit | null
  $data_unit_meta?: DataUnit | null
  $data_extra_unit_meta?: DataUnit | null
  $data_night_unit_meta?: DataUnit | null
  $sms_unit_meta?: SmsUnit | null
  $calls_unit_meta?: CallsUnit | null
  $plan_tag_links?: PlanTagLink[] | null
  $plan_subscription_links?: PlanSubscriptionLink[] | null
  $plan_country_links?: PlanCountryLink[] | null
}

export interface PlanCategoryLinking {
  id: number
  plan_id: number
  category_id: number
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
  $category_meta?: Category | null
  $plan_meta?: Plan | null
}

export interface PlanCountryLink {
  id: number
  plan_id: number
  country_id: number
  created_at: DateTime
  updated_at: DateTime
  $country_meta?: Country | null
  $plan_meta?: Plan | null
}

export interface PlanSubscriptionLink {
  id: number
  plan_id: number
  subscription_id: number
  created_at: DateTime
  updated_at: DateTime
  $subscription_meta?: Subscription | null
  $plan_meta?: Plan | null
}

export interface PlanTagLink {
  id: number
  plan_id: number
  tag_id: number
  created_at: DateTime
  updated_at: DateTime
  $tag_meta?: Tag | null
  $plan_meta?: Plan | null
}

export interface PlansCircleLink {
  id: number
  plan_id: number
  circle_id: number
  operator_id: number
  created_at: DateTime
  updated_at: DateTime
  plan_meta?: Plan | null
  circle_meta?: Circle | null
  operator_meta?: Operator | null
}

export interface SmsUnit {
  id: number
  enable_quantity: boolean
  name: string
  does_renew_everyday: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface Subscription {
  id: number
  dev_key: string
  internal_title: string
  internal_note: string
  name: string
  description: string
  validity: string
  icon_file_name: string
  created_at: DateTime
  updated_at: DateTime
  $plan_subscription_links?: PlanSubscriptionLink[] | null
}

export interface Tag {
  id: number
  label: string
  color: string | null
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface TalktimeUnit {
  id: number
  enable_quantity: boolean
  name: string
  created_at: DateTime
  updated_at: DateTime
}

export interface ValidityUnit {
  id: number
  name: string
  enable_quantity: boolean
  created_at: DateTime
  updated_at: DateTime
  plans?: Plan[] | null
}

export interface MobileCircle {
  id: number
  name: string
  code: string
  long_code: string
  ref_name: string
  ref_name2: string
  created_at: DateTime
  updated_at: DateTime
}

export interface MobileDetect {
  id: number
  digit: number
  operator: number | null
  circle: string | null
  response: string
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderItem {
  id: number
  order_id: number
  item: 'wallet' | 'giftCard'
  sub_item_code: number
  bill_type: BillTypeEnum
  priority_order: number
  additional_info: any
  provider_id: number
  delivery_status: 'none' | 'pending' | 'success' | 'failed' | 'dispatched' | 'processing' | 'review'
  operator_ref: string
  failed_reason: string
  currency: 'INR'
  base_amount: number
  processing_fee: number
  discount: number
  total_amount: number
  pg_amount_used: number
  refund_noservice_amount: number
  refund_serviced_amount: number
  refund_total_amount: number
  ledger_amount: number
  api_last_hit: string
  is_aborted: boolean
  is_locked: boolean
  vendor: 'rcwallet' | 'devTestMode' | 'xoxoday' | null
  vendor_order_id: string | number
  is_bill_generated: boolean
  dependency_order_item_id: number
  recheck_status_sequence: number
  recheck_status_schedule_at: DateTime
  processed_at: DateTime | null
  success_at: DateTime | null
  failed_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  ai_wallet?: OrderItemWallet | null
  ai_giftCard?: OrderItemGiftCard | null
  payment_links?: OrderItemPaymentLink[] | null
  book_bills?: BookBill[] | null
  book_credit_notes?: BookCreditNote[] | null
  book_promotional_expenses?: BookPromotionalExpense[] | null
  order_meta?: Order | null
}

export enum TBO_ResponseStatusEnum {
  NotSet = 0,
  Successfull = 1,
  Failed = 2,
  InValidRequest = 3,
  InValidSession = 4,
  InValidCredentials = 5,
}

export interface AdonisSchema {
  id: number
  name: string
  batch: number
  migration_time: DateTime
}

export interface ApiToken {
  id: number
  user_id: number
  name: string
  type: string
  token: string
  ip: string | null
  expo_version: string | null
  user_agent_id: number
  device_id: number
  guest_uuid: string | null
  device_uuid: string | null
  expires_at: DateTime
  createdAt: DateTime
  updatedAt: DateTime
  clientDeviceInfoMeta?: ClientDeviceInfo | null
  userAgentMeta?: ClientUserAgent | null
}

export interface BannedIp {
  id: number
  ip: string
  reason: 'spam' | 'fraud' | 'other' | 'invalid' | 'duplicate'
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface BookBill {
  id: number
  user_id: number | null
  order_id: number
  order_item_id: number
  order_item_code: 'recharge' | 'wallet' | 'giftCard'
  order_item_sub_code: number
  bill_for: 'service' | 'pf'
  bill_type: BillTypeEnum
  bill_number: number | null
  bill_number_full: string | null
  bill_supplier_id: number
  bill_date: DateTime
  bill_to_gst_number: string | null
  bill_to_state_code: string | null
  bill_to_gst_state_code: string | null
  bill_to_country_code: string | null
  bill_status: BillStatusEnum
  irn: string
  ack_no: string
  ack_date: DateTime
  sac_code: string | null
  hsn_code: string | null
  base_amount: number
  after_tax_discount: number
  after_tax_processing_fee: number
  cgst_rate: number
  cgst_amount: number
  cess_rate: number
  cess_amount: number
  igst_rate: number
  igst_amount: number
  sgst_rate: number
  sgst_amount: number
  before_tax_amount: number
  before_tax_discount: number
  before_tax_processing_fee: number
  taxable_amount: number
  after_tax_amount: number
  document_storage_disk_id: number | null
  document_location: string | null
  created_at: DateTime
  updated_at: DateTime
  documentStorageMeta?: StorageDisk | null
  credit_notes?: BookCreditNote[] | null
  orderItem?: OrderItem | null
  supplier_meta?: BookSupplier | null
}

export interface Store {
  id: number
  source: 'manual' | 'CouponFetcher' | 'Cbs'
  source_key: string
  can_auto_update: boolean
  store_url: string
  store_domain: string
  name: string
  image: string
  type: 'wallet' | 'store' | 'bank' | 'brand' | 'event' | 'product' | 'city' | 'collection'
  terms_and_conditions: string | null
  description: string | null
  rating_type: 'default' | 'strict'
  rating: number | null
  is_active: boolean
  is_best: boolean
  is_on_top: boolean
  is_popular: boolean
  is_featured: boolean
  is_trending: boolean
  is_high_cashback_store: boolean
  is_frequently_used: boolean
  slug: string | null
  priority: number
  created_at: DateTime
  updated_at: DateTime
  $store_category_links?: StoreCategoryLink[] | null
  $store_tag_links?: StoreTagLink[] | null
  $campaign_meta?: Campaign | null
  vendor: 'admitad' | 'trackier'
}

export interface StoreCategoryLink {
  id: number
  store_id: number
  category_id: number
  created_at: DateTime
  updated_at: DateTime
  $category_meta?: Category | null
  $store_meta?: Store | null
}

export interface StoreReview {
  id: number
  store_id: number
  user_id: number
  rating: 1 | 2 | 3 | 4 | 5
  comment: string
  is_visible: boolean
  created_at: DateTime
  updated_at: DateTime
  $store_meta?: Store | null
}

export interface StoreReviewLike {
  id: number
  store_review_id: number
  user_id: number
  is_liked: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface StoreTagLink {
  id: number
  store_id: number
  tag_id: number
  created_at: DateTime
  updated_at: DateTime
  $store_meta?: Store | null
  $tag_meta?: Tag | null
}
export interface BookCreditNote {
  id: number
  user_id: number | null
  order_id: number
  order_item_id: number
  order_item_code: 'recharge' | 'wallet' | 'giftCard'
  order_item_sub_code: number
  book_bill_id: number
  credit_note_status: CreditNoteStatusEnum
  credit_note_number: number | null
  credit_note_number_full: string | null
  credit_note_date: DateTime | null
  irn: string | null
  ack_no: string | null
  ack_date: string | null
  bill_supplier_id: number
  bill_for: 'service' | 'pf'
  bill_type: BillTypeEnum
  bill_to_gst_number: string | null
  bill_to_state_code: string | null
  bill_to_gst_state_code: string | null
  bill_to_country_code: string | null
  sac_code: string | null
  hsn_code: string | null
  cgst_rate: number
  cgst_amount: number
  cess_rate: number
  cess_amount: number
  igst_rate: number
  igst_amount: number
  sgst_rate: number
  sgst_amount: number
  before_tax_amount: number
  before_tax_discount: number
  before_tax_processing_fee: number
  taxable_amount: number
  after_tax_amount: number
  document_storage_disk_id: number | null
  document_location: string | null
  created_at: DateTime
  updated_at: DateTime
  documentStorageMeta?: StorageDisk | null
  supplier_meta?: BookSupplier | null
  billMeta?: BookBill | null
}

export interface BookPromotionalExpense {
  id: number
  order_id: number
  order_item_id: number
  bill_supplier_id: number
  type: BookPromotionalEnum
  amount: number
  reason: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface BookSupplier {
  id: number
  order_id: number
  legal_name: string
  legal_cin_number: string
  tax_gst_number: string
  tax_pan_number: string
  tax_gst_state_code: string
  tax_country_code: string
  address_line_1: string
  address_line_2: string
  address_line_3: string
  city_full: string
  state_full: string
  pin_code: string
  country_full: string
  is_primary: boolean
  last_financial_year: number
  bill_p2p_prefix: string
  bill_p2a_prefix: string
  credit_note_p2p_prefix: string
  credit_note_p2a_prefix: string
  last_bill_date: DateTime
  last_credit_date: DateTime
  last_bill_p2p_sequence: number
  last_bill_p2a_sequence: number
  last_credit_p2p_sequence: number
  last_credit_p2a_sequence: number
  created_at: DateTime
  updated_at: DateTime
}

export interface ClientDeviceInfo {
  id: number
  platform_os: string | null
  brand: string | null | undefined
  designName: string | null | undefined
  deviceYearClass: number | null | undefined
  isDevice: boolean | null | undefined
  manufacturer: string | null | undefined
  modelId: string | null | undefined
  modelName: string | null | undefined
  osBuildFingerprint: string | null | undefined
  osBuildId: string | null | undefined
  osInternalBuildId: string | null | undefined
  osName: string | null | undefined
  osVersion: string | null | undefined
  platformApiLevel: number | null | undefined
  productName: string | null | undefined
  created_at: DateTime
  updated_at: DateTime
}

export interface ClientUserAgent {
  id: number
  user_agent: string
  created_at: DateTime
  updated_at: DateTime
}

export interface CouponCode {
  id: number
  type: 'public' | 'private' | 'signup'
  public_code: string
  coupon_definition_id: number
  config: {}
  created_at: DateTime
  updated_at: DateTime
  user_id: number
  coupon_definition_meta?: CouponDefinition | null
}

export interface CouponDefinition {
  id: number
  hook_code: string
  title: string
  description: string
  validity: DateTime
  config: {}
  created_at: DateTime
  updated_at: DateTime
}

export interface CouponShowcase {
  id: number
  coupon_code_id: number
  utm_id: number
  item: 'recharge' | 'wallet' | 'giftCard'
  item_code: string | number | null
  platform: 'rc' | 'rm'
  created_at: DateTime
  updated_at: DateTime
  coupon_code_meta?: CouponCode | null
}

export interface EnvSetting {
  key: string
  value: string
  jsonData: any
  safeData: any
  is_locked: boolean
  created_at: DateTime
  updated_at: DateTime
}

export enum CampaignStatus {
  UNSPECIFIED = 0,
  UNKNOWN = 1,
  ENABLED = 2,
  PAUSED = 3,
  REMOVED = 4,
}

export interface GoogleAdsCampaign {
  id: number
  campaign_id: number
  campaign_name: string
  status: CampaignStatus
  item: 'recharge' | 'wallet' | 'giftCard'
  sub_item_code: number
  created_at: DateTime
  updated_at: DateTime
}

export interface Order {
  id: number
  order_key: string
  user_id: number | undefined
  staff_id: number | null | undefined
  currency: 'INR'
  total_oi_amount: number
  coupon_id: number | null
  undefined: any
  payment_status: 'none' | 'initiated' | 'success' | 'mismatch' | 'delayed' | 'pending'
  paid_amount_virtual: number
  paid_amount_actual: number
  paid_amount_total: number
  refund_amount_total: number
  ledger_amount: number
  api_process_required: boolean
  api_processing: boolean
  api_processed: boolean
  tax_processed: boolean
  api_tag1: string
  api_tag2: string
  api_tag3: string
  api_tag4: string
  is_locked: boolean
  platform: 'rc'
  device: 'web' | 'app'
  utm_id: number
  has_displayed_utm_code: boolean
  created_at: DateTime
  updated_at: DateTime
  items?: OrderItem[] | null
  bill_detail?: OrderBillDetail | null
  ship_detail?: OrderShipDetail[] | null
  payment_wall?: PaymentWall[] | null
  coupon_meta?: CouponCode | null
  actions?: OrderAction[] | null
  refunds?: OrderRefund[] | null
  order_cashbacks?: OrderCashback[] | null
  staff?: Staff | null
  book_bills?: BookBill[] | null
  book_credit_notes?: BookCreditNote[] | null
  pre_payment_config: {
    wallet_used: { wallet_id: number; amount: number; pw_id: number }[]
    pg_amount: number
    wallet_amount: number
    coupon_amount: number
    isComputed: boolean
  }
  is_refund_required: boolean
  refund_scheduled_at: DateTime
  user_meta?: User | null
}

export interface OrderAction {
  id: number
  order_id: number
  order_item_id: number
  action_type: string
  staff_id: number
  user_comment: string
  system_comment: string
  staff?: Staff | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderBillDetail {
  id: number
  order_id: number
  legal_name: string
  tax_gst_number: string | null
  tax_pan_number: string | null
  tax_gst_state_code: string | null
  tax_country_code: string
  mobile_number: string
  email: string
  addressLine1: string | null
  addressLine2: string | null
  addressLine3: string | null
  city: string
  state: string
  pin_code: string
  country: string
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderCashback {
  id: number
  order_id: number
  wallet_id: number
  currency: 'INR'
  amount: number
  reversed_amount: number
  scheduled_at: DateTime
  is_credited: boolean
  is_locked: boolean
  created_at: DateTime
  updated_at: DateTime
  wallet_meta?: Wallet | null
  order_meta?: Order | null
}

export interface OrderFeedback {
  id: number
  order_id: number
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  user_ip: string | null
  rating: 1 | 2 | 3 | 4 | 5
  feedback: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderGuestCashback {
  id: number
  order_id: number
  wallet_type: 'money' | 'promo' | 'voucher'
  currency: 'INR'
  amount: number
  reversed_amount: number
  is_credited: boolean
  created_at: DateTime
  updated_at: DateTime
  order_meta?: Order | null
}
export interface OrderItemPaymentLink {
  id: number
  order_item_id: number
  payment_wall_id: number
  used_amount: number
  created_at: DateTime
  updated_at: DateTime
  payment_wall_meta?: PaymentWall | null
}

export interface OrderItemGiftCard {
  id: number
  order_item_id: number
  giftcard_voucher_id: number
  quantity: number
  denomination: number
  receivers_name: string | null
  receivers_email: string
  receivers_mobile: string
  xoxoday_place_order_request:
    | {
        productId: number
        quantity: number
        denomination: number
        email?: string | undefined
        contact?: string | undefined
        tag?: string | undefined
        poNumber?: string | undefined
        notifyReceiverEmail: boolean
      }
    | undefined
  xoxoday_place_order_response:
    | {
        code: undefined
        data?:
          | {
              placeOrder?:
                | {
                    status: 0 | 1
                    data?:
                      | {
                          orderId: number
                          vouchers: {
                            amount: number
                            country: string
                            currency: string
                            orderId: number
                            pin: string
                            productId: number
                            type: string
                            validity: string
                            voucherCode: string
                            currencyValue: number
                          }[]
                          amountCharged: number
                          currencyCode: string
                          tag: string
                          currencyValue: number
                          discountPercent: number
                          orderDiscount: number
                          orderTotal: number
                          orderStatus: string
                          deliveryStatus: string
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
      }
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError400
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError401
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError403
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError404
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError422
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError409
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError502
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError500
    | undefined
  xoxoday_get_order_details_request:
    | { poNumber?: string | undefined; orderId?: number | undefined; sendMailToReceiver?: '1' | '0' | undefined }
    | undefined
  xoxoday_get_order_details_response:
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError400
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError401
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError404
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError502
    | import('D:/Work/ORIGIN_CRM_ADONIS/rc-cashback-adonis/app/SubModules/giftCard/Services/OrderItem/hooks/xoxoday/api/commonTypes').xoxoDayError500
    | {
        code: undefined
        data?:
          | {
              getOrderDetails?:
                | {
                    status: 0 | 1
                    data?:
                      | {
                          orderId: number
                          vouchers?:
                            | {
                                amount: number
                                country: string
                                currency: string
                                orderId: number
                                pin: string
                                productId: number
                                tag: string
                                type: string
                                validity: string
                                voucherCode: string
                                currencyValue: number
                              }[]
                            | undefined
                          amountCharged: number
                          currencyCode: string
                          currencyValue: number
                          discountPercent: number
                          orderDiscount: number
                          orderTotal: number
                          orderStatus: string
                          deliveryStatus: string
                        }
                      | undefined
                  }
                | undefined
            }
          | undefined
      }
    | undefined
  xoxoday_order_id: number | undefined
  xoxoday_order_status: 'none' | 'pending' | 'success' | 'failed' | undefined
  gift_voucher_meta?: GiftVoucher | null
  $vouchers?: OrderItemGiftCardVoucher[] | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface GiftVoucher {
  id: number
  gift_brand_id: number | null
  sync_source: string
  sync_source_id: string
  sync_can_auto_update: boolean
  name: string
  undefined: any
  description: string
  terms_and_conditions_instructions: string
  expiry_and_validity: string
  redemption_instructions: string
  last_update_date: string
  is_active: boolean
  is_mobile_showcase: boolean
  order: number
  image: string
  created_at: DateTime
  updated_at: DateTime
  $gift_voucher_vendor_meta?: GiftVoucherVendor | null
  $gift_voucher_category_links?: GiftVoucherCategoryLink[] | null
  $gift_brand_meta?: GiftBrand | null
}

export interface GiftBrand {
  id: number
  created_by: 'xoxoday' | 'self'
  name: string
  image: string
  is_active: boolean
  has_admin_modified: boolean
  createdAt: DateTime
  updatedAt: DateTime
}

export interface GiftVoucherCategory {
  id: number
  created_by: 'xoxoday' | 'self'
  name: string
  order: number
  has_admin_modified: boolean
  is_active: boolean
  createdAt: DateTime
  updatedAt: DateTime
}

export interface GiftVoucherCategoryLink {
  id: number
  voucher_category_id: number
  voucher_id: number
  createdAt: DateTime
  updatedAt: DateTime
  $gift_voucher_category_meta?: GiftVoucherCategory | null
  $gift_voucher_meta?: GiftVoucher | null
}

export interface GiftVoucherVendor {
  id: number
  gift_vendor_id: number
  gift_voucher_id: number
  default_hook: 'rcwallet' | 'devTestMode' | 'xoxoday'
  config: { xoxoday_product_id?: number | undefined }
  value_type: 'open_value' | 'fixed_denomination'
  max_value: number
  min_value: number
  value_denominations: number[]
  tat_in_days: number
  undefined: any
  usage_type: 'online' | 'offline' | 'both' | undefined
  delivery_type: 'delayed' | 'realtime'
  fee: number
  discount: number
  is_available: boolean
  $gift_vendor_meta: GiftVendor & {
    readonly __opaque_type: 'belongsTo'
    model: typeof GiftVendor
    instance: GiftVendor
    client: import('@ioc:Adonis/Lucid/Orm').BelongsToClientContract<
      import('@ioc:Adonis/Lucid/Orm').BelongsToRelationContract<import('@ioc:Adonis/Lucid/Orm').LucidModel, typeof GiftVendor>,
      typeof GiftVendor
    >
    builder: import('@ioc:Adonis/Lucid/Orm').RelationQueryBuilderContract<typeof GiftVendor, any>
    subQuery: import('@ioc:Adonis/Lucid/Orm').RelationSubQueryBuilderContract<typeof GiftVendor>
  }
  createdAt: DateTime
  updatedAt: DateTime
}

export interface OrderItemGiftCardVoucher {
  id: number
  order_item_gift_card_id: number
  amount: number
  country: string
  currency: string
  order_id: number
  pin: string
  tag: string
  type: string
  validity: string
  voucher_code: string
  currency_value: number
  createdAt: DateTime
  updatedAt: DateTime
}

export interface OrderItemWallet {
  id: number
  order_item_id: number
  wallet_id: number
  amount: number
  created_at: DateTime
  updated_at: DateTime
  wallet_meta?: Wallet | null
}

export interface OrderRefund {
  id: number
  order_id: number
  mode: 'wallet' | 'cashgram' | 'original' | 'manual'
  amount: number
  status: StatusEnum
  bank_ref: string | number | undefined
  refund_reason: string
  refund_fail_reason: string | null
  is_locked: boolean
  api_res_data: any
  recheck_status_sequence: number | null
  recheck_status_schedule_at: DateTime
  vendor_request_id: string
  vendor_processed_at: DateTime | null
  processed_at: DateTime | null
  success_at: DateTime | null
  failed_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  paymentWallLink?: OrderRefundPaymentLink[] | null
  order_meta?: Order | null
}

export interface OrderRefundPaymentLink {
  id: number
  refund_id: number
  payment_wall_id: number
  used_amount: number
  payment_wall_meta?: PaymentWall | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderShipDetail {
  id: number
  order_id: number
  first_name: string
  last_name: string
  mobile_number: string
  email: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  state: string
  pin_code: string
  country: string
  is_primary: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface OtpValidation {
  id: number
  code: string
  user_id: number
  type: 'login' | 'change_email'
  mobile: string
  email: string
  config: { type: 'change_email'; newEmail: string } | undefined
  isVerified: boolean
  isSentOnMobile: boolean
  isSentOnEmail: boolean
  sentAt: DateTime
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentBankCode {
  id: number
  bank_name: string
  order: string
  bank_type: string
  payubiz: string
  traknpay: string
  cashFree: string
  default: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentWall {
  id: number
  order_id: number
  gateway_payment_id: string
  gateway_payment_id2: string
  payment_status: 'none' | 'pending' | 'success' | 'failed' | 'cancelled'
  currency: 'INR'
  amount: number
  remaining_amount: number
  it_error_code: string
  pg_method: string
  pg_bank_utr: string | null
  pg_sub_gateway_provider: string
  pg_vpa: string | null
  pg_bank: string | null
  pw_card_id: number | null
  pg_wallet: string | null
  pg_error_code: string
  pg_error_message: string
  us_is_debited: boolean
  us_is_cancelled: boolean
  it_pg_channel: 'cashfree' | 'self' | 'payubiz' | 'razorpay' | undefined
  us_pg_mode: string
  us_pg_code: string | number
  us_away_time: DateTime
  us_back_time: DateTime
  us_payment_time: DateTime
  is_locked: boolean
  has_sent_to_processing: boolean
  is_synced: boolean
  recheck_status_sequence: number
  recheck_status_schedule_at: DateTime | null
  failed_at: DateTime | null
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  created_at: DateTime
  updated_at: DateTime
  transactions?: PaymentWallTransaction[] | null
  order_meta?: Order | null
  card_meta?: PaymentWallCard | null
}

export interface PaymentWallCard {
  id: number
  it_pg_channel: string | null
  gateway_card_id: string | null
  name: string | null
  last4: number | null
  network: string | null
  type: string | null
  issuer: string | null
  international: boolean | null
  emi: boolean | null
  sub_type: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentWallTransaction {
  id: number
  payment_id: number
  order_id: number
  amount: number
  opening_balance: number
  closing_balance: number
  type: 'debit' | 'credit'
  description: string
  created_at: DateTime
  updated_at: DateTime
}

export interface RecentSearch {
  id: number
  type: string
  payload: {}
  staff_id: number
  user_id: number
  created_at: DateTime
  updated_at: DateTime
}

export interface ReferEarnCreate {
  id: number
  user_id: number
  refer_earn_definition_id: number
  expiry_at: DateTime
  created_at: DateTime
  updated_at: DateTime
  referEarnDefinition?: ReferEarnDefinition | null
  userMeta?: User | null
  urlStats?: ReferEarnUrlStat[] | null
  onboards?: ReferEarnOnboard[] | null
  credits?: ReferEarnCredit[] | null
}

export interface ReferEarnCredit {
  id: number
  refer_earn_onboard_id: number
  refer_earn_create_id: number
  refer_from_user_id: number
  wallet_type: 'money' | 'promo' | 'voucher'
  wallet_id: number
  amount: number
  created_at: DateTime
  updated_at: DateTime
  walletMeta?: Wallet | null
}

export interface ReferEarnDefinition {
  id: number
  hook_code: 'GET10p5v_GIVE50p' | 'GET10v_GIVE50p' | 'GET20p_GIVE50p' | 'GET10p2v_GIVE20p' | 'GET2v_GIVE2v'
  title: string
  description_give: string
  description_get: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface ReferEarnOnboard {
  id: number
  refer_earn_create_id: number
  refer_from_user_id: number
  refer_to_user_id: number
  status: 'signup' | 'completed' | 'cexpired' | null
  undefined: any
  created_at: DateTime
  updated_at: DateTime
  referEarnCreate?: ReferEarnCreate | null
  onboards?: ReferEarnCredit[] | null
  credits?: ReferEarnCredit[] | null
  referToUserMeta?: User | null
}

export interface ReferEarnUrlStat {
  id: number
  refer_earn_create_id: number
  ip_address: string
  user_agent: string
  created_at: DateTime
  updated_at: DateTime
}

export interface ReviewPrompt {
  id: number
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  user_id: number | undefined
  guest_uuid: string | null
  device_uuid: string | null
  user_ip: string | null
  initiator_reason: 'order' | 'cashback'
  type: 'in-app' | 'external'
  external_review_url: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface ScratchCoupon {
  id: number
  website_domain: string
  hook: 'cashback'
  title: string
  subtitle: string
  heading: string
  static_coupon_code: string | null
  static_validity_date: DateTime | null
  static_valid_days: number | null
  static_coupon_type: string | null
  details: string | null
  terms: string | null
  redeem_target: 'self' | 'url'
  redeem_url: string | null
  ui_tag: 'wallet' | 'coupon' | null
  created_at: DateTime
  updated_at: DateTime
  website?: Website | null
}

export interface ScratchMyReward {
  id: number
  website_domain: string
  hook: 'cashback'
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  order_id: number | null
  is_scratched: boolean
  is_better_luck_next_time: boolean
  scratch_coupon_json: {
    id: number
    created_at: DateTime
    updated_at: DateTime
    title: string
    subtitle: string
    website_domain: string
    hook: 'cashback'
    heading: string
    static_coupon_code: string | null
    static_validity_date: DateTime | null
    static_valid_days: number | null
    static_coupon_type: string | null
    details: string | null
    terms: string | null
    redeem_target: 'self' | 'url'
    redeem_url: string | null
    ui_tag: 'wallet' | 'coupon' | null
  }
  expires_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  scratchMyRewardCashback?: ScratchMyRewardCashback | null
  website?: Website | null
}

export interface ScratchMyRewardCashback {
  id: number
  scratch_my_reward_id: number
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  wallet_type: 'money' | 'promo' | 'voucher'
  amount: number
  transaction_amount: number
  should_consider_in_wallet: boolean
  is_redeemed: boolean
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface StaticAirport {
  id: number
  airport_id: number
  name: string
  city: string
  country: string
  iata: string | null
  icao: string | null
  latitude: number
  longitude: number
  altitude: number
  timezone: string
  daylight_saving_time: string
  dz_database_time: string
  type: string
  source: string
  created_at: DateTime
  updated_at: DateTime
}

export interface Staff {
  id: number
  email: string
  mobile: string
  name: string
  role: string
  password: string
  rememberMeToken: string | undefined
  created_at: DateTime
  updated_at: DateTime
  is_active: boolean
  pin: number | null
  notifications?: Notification[] | null
  notificationSubscriptions?: NotificationSubscription[] | null
  recentSearches?: RecentSearch[] | null
}

export interface StaffNote {
  id: number
  staff_id: number
  reference_type: 'order' | 'user'
  reference_id: number
  note: string
  created_at: DateTime
  updated_at: DateTime
}

export interface StaticState {
  id: number
  type: string
  name: string
  country_code: string
  state_code: string
  iso_3166_2: string
  vehicle_code: string
  zone: string
  gst_code: string
  created_at: DateTime
  updated_at: DateTime
}

export interface StorageDisk {
  id: number
  type: 's3' | 'disk'
  public_url: string | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface User {
  id: number
  name: string
  email: string
  mobile: string
  is_email_verified: boolean
  is_mobile_verified: boolean
  is_profile_completed: boolean
  is_security_locked: boolean
  has_completed_kyc: boolean
  undefined: any
  password: string
  rememberMeToken: string | undefined
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  signup_ip: string | null
  created_at: DateTime
  updated_at: DateTime
  referPrefix: number | undefined
  wallet?: Wallet[] | null
  orders?: Order[] | null
  referEarnOnboard?: ReferEarnOnboard | null
  referEarnCreates?: ReferEarnCreate[] | null
  notifications?: Notification[] | null
  notificationSubscriptions?: NotificationSubscription[] | null
  primaryBillDetail?: UserBillDetail | null
  bill_details?: UserBillDetail[] | null
  otpValidations?: OtpValidation[] | null
  userKyc?: UserKyc | null
  userLimit?: UserLimit[] | null
  userKycFullTickets?: UserKycFullTicket[] | null
  scratchMyRewards?: ScratchMyReward[] | null
  scratchMyRewardCashbacks?: ScratchMyRewardCashback[] | null
}

export interface UserBillDetail {
  id: number
  user_id: number
  legal_name: string
  tax_gst_number: string | null
  tax_pan_number: string | null
  tax_gst_state_code: string
  tax_country_code: string
  mobile_number: string
  email: string
  addressLine1: string | null
  addressLine2: string | null
  addressLine3: string | null
  city: string
  state: string
  pin_code: string
  country: string
  is_primary: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface UserKyc {
  id: number
  user_id: number
  verified_aadhaar_no: string | null
  verified_pan_no: string | null
  verified_full_kyc_ticket_id: number | null
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

export interface UserKycAadhaarRequest {
  id: number
  user_id: number
  aadhaar_no: string
  ref_id: string
  hook_code: 'cashfree'
  verification_response:
    | null
    | (
        | {
            status: undefined
            type: string
            code: string
            message: string
          }
        | {
            status: 'VALID'
            message: string
            ref_id: string
            care_of: string
            address: string
            dob: string
            email: string
            gender: string
            name: string
            photo_link: string
            mobile_hash: string
            split_address: {
              country: string
              dist: string
              house: string
              landmark: string
              pincode: string
              postOffice: string
              state: string
              street: string
              subdist: string
              vtc: string
            }
            year_of_birth: string
          }
      )
  status: 'pending' | 'success' | 'failed'
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface UserKycFullTicket {
  id: number
  user_id: number
  freshdesk_ticket_id: number
  status: 'pending' | 'success' | 'failed'
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

export interface UserKycPanRequest {
  id: number
  pan_no: string
  user_id: number
  hook_code: 'cashfree'
  status: 'pending' | 'success' | 'failed'
  verification_response: null | {
    json:
      | {
          valid: true
          pan: string
          type: 'Individual' | 'Company'
          reference_id: number
          name_provided: string
          registered_name: string //Pan name
          message: string
        }
      | {
          valid: false
          type: undefined
          pan: string
          reference_id: number
          name_provided: string
          message: string
        }
      | {
          valid: undefined
          type: string //eg : internal_error
          code: string //eg: api_error
          message: string //eg: something went wrong, please try after some time
        }
  }
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface UserLimit {
  id: number
  user_id: number
  module_type: 'wallet'
  module_subtype: string
  utilized_limit_start_date: DateTime
  limit_period: 'monthly'
  limit_amount: number
  utilized_limit_amount: number
  created_at: DateTime
  updated_at: DateTime
}

export interface Utm {
  id: number
  utm_source: string
  utm_medium: string
  utm_campaign: string
  short_code: string
  config: {}
  created_at: DateTime
  updated_at: DateTime
}

export interface Wallet {
  id: number
  user_id: number
  balance: number
  is_locked: boolean
  currency: 'INR'
  type: 'money' | 'promo' | 'voucher' | 'earning'
  default_order: number
  created_at: DateTime
  updated_at: DateTime
  statement?: WalletTransaction[] | null
}

export interface WalletTransaction {
  id: number
  wallet_id: number
  service: string
  service_id: number
  service_date: DateTime
  service_provider_id: number
  type: 'debit' | 'credit'
  amount: number
  opening_balance: number
  closing_balance: number
  created_at: DateTime
  undefined: any
  updated_at: DateTime
}

export interface WalletVoucher {
  id: number
  provider_id: number
  code: string
  wallet_type: 'money' | 'promo' | 'voucher' | 'earning'
  amount: number
  status: 'pending' | 'applied'
  user_id: number | null | undefined
  staff_id: number | null | undefined
  is_locked: boolean
  expiry_at: DateTime
  applied_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

/**
 * Routes used in the project
 */
export interface APP_ROUTES {
  ADMIN_AUTH_LOGIN: {
    request: {
      header: any
      validation: {
        email: string
        password: string
        remember_me: boolean | undefined
      }
    }
    response: { code: 200; token: { token: string }; staff: Staff }
  }

  ADMIN_AUTH_CHECK: {
    request: {
      header: any
      validation: any
    }
    response: { code: 200; staff: Staff; recentSearches: { [k: string]: Object } }
  }

  ADMIN_AUTH_LOGOUT: {
    request: {
      header: any
      validation: any
    }
    response: { code: 200 }
  }

  ADMIN_ANALYTICS_BASIC: {
    request: {
      header: any
      validation: {
        from: DateTime
        to: DateTime
      }
    }
    response: {
      code: 200
      data: {
        userMeta: { total_count: number; is_email_verified: number; is_mobile_verified: number; is_profile_completed: number }
        orderMeta: Partial<{
          wallet: Partial<{
            none: { count: number; base_amount: number; discount: number; total_amount: number }
            pending: { count: number; base_amount: number; discount: number; total_amount: number }
            success: { count: number; base_amount: number; discount: number; total_amount: number }
            failed: { count: number; base_amount: number; discount: number; total_amount: number }
            dispatched: { count: number; base_amount: number; discount: number; total_amount: number }
            processing: { count: number; base_amount: number; discount: number; total_amount: number }
            review: { count: number; base_amount: number; discount: number; total_amount: number }
          }>
          giftCard: Partial<{
            none: { count: number; base_amount: number; discount: number; total_amount: number }
            pending: { count: number; base_amount: number; discount: number; total_amount: number }
            success: { count: number; base_amount: number; discount: number; total_amount: number }
            failed: { count: number; base_amount: number; discount: number; total_amount: number }
            dispatched: { count: number; base_amount: number; discount: number; total_amount: number }
            processing: { count: number; base_amount: number; discount: number; total_amount: number }
            review: { count: number; base_amount: number; discount: number; total_amount: number }
          }>
        }>
        referMeta: Partial<{ signup: { count: number }; completed: { count: number }; cexpired: { count: number } }>
      }
    }
  }

  ADMIN_REPORT_SALE: {
    request: {
      header: any
      validation: {
        from: DateTime
        to: DateTime
      }
    }
    response: { code: 200; data: string }
  }

  ADMIN_REPORT_GETPLANCOUNT: {
    request: {
      header: any
      validation: {
        operator: number
        from: DateTime
        to: DateTime
        status: 'pending' | 'success' | 'failed'
      }
    }
    response: { code: 200; data: { plan: number; count: number }[] }
  }

  ADMIN_REPORT_GETCIRCLECOUNT: {
    request: {
      header: any
      validation: {
        operator: number
        from: DateTime
        to: DateTime
        plan: number
        status: 'pending' | 'success' | 'failed'
      }
    }
    response: { code: 200; data: { circle: ModelAttributes<Circle> | null; count: number }[] }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_LIST: {
    request: {
      header: any
      validation: {
        search: string | undefined
        page: number
        perPage: number
        orderBy: 'id' | 'campaign_id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<GoogleAdsCampaign> }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_CREATE: {
    request: {
      header: any
      validation: {
        campaign_id: number
        campaign_name: string
        item: 'recharge' | 'wallet' | 'giftCard'
        sub_item_code: number
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: GoogleAdsCampaign; message?: undefined }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        campaign_id: number
        campaign_name: string
        item: 'recharge' | 'wallet' | 'giftCard'
        sub_item_code: number
      }
    }
    response: { code: 200; data: GoogleAdsCampaign }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200 }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_RECHECKSTATUS: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_ENABLE: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_DISABLE: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_STAFF_NOTES_LIST: {
    request: {
      header: any
      validation: {
        staff_id: number | undefined
        reference_type: string | undefined
        reference_id: number | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<StaffNote> }
  }

  ADMIN_STAFF_NOTES_CREATE: {
    request: {
      header: any
      validation: {
        reference_type: 'order' | 'user'
        reference_id: number
        note: string
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_NOTES_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_NOTES_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        note: string
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_LIST: {
    request: {
      header: any
      validation: {
        name: string | undefined
        email: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Staff> }
  }

  ADMIN_STAFF_CREATE: {
    request: {
      header: any
      validation: {
        name: string
        is_active: boolean
        email: string
        mobile: string
        role: string
        password: string
        pin: number
      }
    }
    response: { code: 200; data: Staff }
  }

  ADMIN_STAFF_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        name: string
        is_active: boolean
        email: string
        mobile: string
        role: string
        password: string | undefined
        pin: number
      }
    }
    response: { code: 200; data: Staff }
  }

  ADMIN_STAFF_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_USER_LIST: {
    request: {
      header: any
      validation: {
        name: string | undefined
        mobile: string | undefined
        email: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<User> }
  }

  ADMIN_USER_UPDATEBLOCK: {
    request: {
      header: any
      validation: {
        user_id: number
        is_blocked: boolean
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_UPDATEKYC: {
    request: {
      header: any
      validation: {
        user_id: number
        is_completed: boolean
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_KYC_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        user_id: number | undefined
        verified_aadhaar_no: string | undefined
        verified_pan_no: string | undefined
        verified_full_kyc_ticket_id: number | undefined
      }
    }
    response: {
      code: 200
      data: ModelPaginatorContract<
        UserKyc & {
          panResponse: UserKycPanRequest | null
          aadhaarResponse: UserKycAadhaarRequest | null
          id: number
          created_at: DateTime
          updated_at: DateTime
          user_id: number
          verified_aadhaar_no: string | null
          verified_pan_no: string | null
          verified_full_kyc_ticket_id: number | null
        }
      >
    }
  }

  ADMIN_USER_KYC_FULLTICKET_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        user_id: number | undefined
        freshdesk_ticket_id: number | undefined
        status: 'pending' | 'success' | 'failed' | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<UserKycFullTicket> }
  }

  ADMIN_USER_KYC_FULLTICKET_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        user_id: number
        freshdesk_ticket_id: number
        status: 'success' | 'failed'
      }
    }
    response: { code: 200; data: UserKycFullTicket }
  }

  ADMIN_USER_KYC_FULLTICKET_CREATE: {
    request: {
      header: any
      validation: {
        user_id: number
        freshdesk_ticket_id: number
        status: 'success' | 'failed'
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: UserKycFullTicket; message?: undefined }
  }

  ADMIN_USER_LIMIT_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        user_id: number
        limit_amount: number
      }
    }
    response: { code: 200; data: UserLimit }
  }

  ADMIN_PAYMENT_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        amount: number | undefined
        it_pg_channel: 'cashfree' | 'self' | 'payubiz' | 'razorpay' | undefined
        payment_status: 'pending' | 'success' | 'failed' | 'cancelled' | undefined
        order_id: number | undefined
        gateway_payment_id: string | undefined
        gateway_payment_id2: string | undefined
        pg_method: string | undefined
        pg_sub_gateway_provider: string | undefined
        pg_bank_utr: string | undefined
        pg_vpa: string | undefined
        pg_bank: string | undefined
        pg_wallet: string | undefined
        user_id: number | undefined
        card:
          | {
              it_pg_channel: 'cashfree' | 'payubiz' | 'razorpay' | undefined
              gateway_card_id: string | undefined
              name: string | undefined
              last4: number | undefined
              network: string | undefined
              type: string | undefined
              issuer: string | undefined
              international: boolean | undefined
              emi: boolean | undefined
              sub_type: string | undefined
            }
          | undefined
        from: DateTime | undefined
        to: DateTime | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<PaymentWall> }
  }

  ADMIN_PAYMENT_LISTSEARCHMETA: {
    request: {
      header: any
      validation: any
    }
    response: {
      code: 200
      data: {
        pg_bank: string[]
        pg_wallet: string[]
        pg_method: string[]
        pg_sub_gateway_provider: string[]
        card: { network: string[]; type: string[]; issuer: string[]; sub_type: string[] }
      }
    }
  }

  ADMIN_ORDER_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response:
      | { code: 500; message: string; data?: undefined }
      | {
          code: 200
          data: Order & {
            pgStat: orderPGStatType
          }
          message?: undefined
        }
  }

  ADMIN_ORDER_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
        order: { id: number | undefined; payment_status: string | undefined } | undefined
        user: { id: number | undefined; mobile: string | undefined; email: string | undefined } | undefined
        order_item:
          | {
              id: number | undefined
              item: 'wallet' | 'recharge' | undefined
              sub_item_code: string | undefined
              operator_ref: string | undefined
              base_amount: number | undefined
              total_amount: number | undefined
              delivery_status: 'none' | 'pending' | 'success' | 'failed' | 'dispatched' | 'processing' | 'review' | undefined
            }
          | undefined
        order_item_wallet: { amount: number | undefined } | undefined
        order_refunds: { mode: string | undefined; amount: number | undefined; status: string | undefined; bank_ref: string | undefined } | undefined
        bill_detail:
          | {
              legal_name: string | undefined
              tax_gst_number: string | undefined
              tax_pan_number: string | undefined
              tax_gst_state_code: string | undefined
              tax_country_code: string | undefined
              mobile_number: string | undefined
              email: string | undefined
            }
          | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Order & { pgStat: orderPGStatType }> }
  }

  ADMIN_ORDER_ONHOLDPAYMENTACTION: {
    request: {
      header: any
      validation: {
        order_id: number
        action: 'withdraw' | 'process'
        withdraw_destination: 'wallet' | 'cashgram' | 'original' | 'manual' | undefined
        comment: string | undefined
      }
    }
    response: { code: number }
  }

  ADMIN_ORDER_ITEM_RECHECKSINGLEITEM: {
    request: {
      header: any
      validation: {
        order_item_id: number
      }
    }
    response: { code: 200; data: OrderItem }
  }

  ADMIN_ORDER_ITEM_RECHECKSINGLEITEMDEBUGLOGS: {
    request: {
      header: any
      validation: {
        order_item_id: number
      }
    }
    response: { code: 200; data: string }
  }

  ADMIN_ORDER_ITEM_UPDATESINGLEITEMSTATUS: {
    request: {
      header: any
      validation: {
        order_item_id: number
        delivery_status: 'success' | 'failed'
        operator_ref: string | undefined
        comment: string | undefined
      }
    }
    response: { code: 200; data: OrderItem }
  }

  ADMIN_ORDER_PAYMENT_RECHECKSINGLESTATUS: {
    request: {
      header: any
      validation: {
        payment_wall_id: number
      }
    }
    response: { code: 200; data: PaymentWall }
  }

  ADMIN_ORDER_PAYMENT_RECHECKALLSTATUS: {
    request: {
      header: any
      validation: {
        order_id: number
      }
    }
    response: { code: 200; data: PaymentWall[] }
  }

  ADMIN_ORDER_REFUND_RECHECKSINGLESTATUS: {
    request: {
      header: any
      validation: {
        refund_id: number
      }
    }
    response: { code: 200; data: OrderRefund; additionalInfo: any }
  }

  ADMIN_ORDER_REFUND_RECHECKALLSTATUS: {
    request: {
      header: any
      validation: {
        order_id: number
      }
    }
    response: { code: 200; data: OrderRefund[] }
  }

  ADMIN_WALLET_STATEMENT: {
    request: {
      header: any
      validation: {
        wallet_type: 'money' | 'promo' | 'voucher' | 'earning'
        user_id: number
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<WalletTransaction & { title: string }> }
  }

  ADMIN_WALLET_DEDUCT: {
    request: {
      header: any
      validation: {
        user_id: number
        amount: number
        type: 'debit' | 'credit'
        wallet_type: 'money' | 'promo' | 'voucher' | 'earning'
        reason: string
      }
    }
    response: { code: number; message: string } | { code: 200; message?: undefined }
  }

  ADMIN_WALLET_VOUCHER_LIST: {
    request: {
      header: any
      validation: {
        user: { mobile: string | undefined; email: string | undefined } | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
        code: string | undefined
        wallet_type: 'money' | 'promo' | 'voucher' | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<WalletVoucher> }
  }

  ADMIN_WALLET_VOUCHER_CREATE: {
    request: {
      header: any
      validation: {
        user_id: number | undefined
        wallet_type: 'promo' | 'voucher' | 'earning'
        amount: number
        expireAfterDays: number
      }
    }
    response: { code: 200; data: WalletVoucher }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Category }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_LIST: {
    request: {
      header: any
      validation: {
        is_active: boolean | undefined
        is_on_top: boolean | undefined
        is_popular: boolean | undefined
        is_featured: boolean | undefined
        is_trending: boolean | undefined
        is_frequently_used: boolean | undefined
        parent_id: number | undefined
        parent_list_only: boolean | undefined
        search: string | undefined
        is_store_image_available: boolean | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Category> }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_CREATE: {
    request: {
      header: any
      validation: {
        name: string
        description: string
        is_active: boolean
        is_on_top: boolean
        is_popular: boolean
        is_featured: boolean
        is_trending: boolean
        is_frequently_used: boolean
        parent_id: number | undefined
        image: MultipartFileContract | undefined
      }
    }
    response: { code: 200; data: Category }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        parent_id: number | undefined
        name: string
        description: string
        is_active: boolean
        is_on_top: boolean
        is_popular: boolean
        is_featured: boolean
        is_trending: boolean
        is_frequently_used: boolean
        image: MultipartFileContract | undefined
      }
    }
    response: { code: 200; data: Category }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_BANK_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Bank }
  }

  ADMIN_STATICDATA_COUPON_BANK_LIST: {
    request: {
      header: any
      validation: {
        is_active: boolean | undefined
        search: string | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Bank> }
  }

  ADMIN_STATICDATA_COUPON_BANK_CREATE: {
    request: {
      header: any
      validation: {
        name: string
        is_active: boolean
      }
    }
    response: { code: 200; data: Bank }
  }

  ADMIN_STATICDATA_COUPON_BANK_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        name: string
        is_active: boolean
      }
    }
    response: { code: 200; data: Bank }
  }

  ADMIN_STATICDATA_COUPON_BANK_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_TAG_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Tag }
  }

  ADMIN_STATICDATA_COUPON_TAG_LIST: {
    request: {
      header: any
      validation: {
        is_active: boolean | undefined
        search: string | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Tag> }
  }

  ADMIN_STATICDATA_COUPON_TAG_CREATE: {
    request: {
      header: any
      validation: {
        label: string
        color: string | undefined
        is_active: boolean
      }
    }
    response: { code: 200; data: Tag }
  }

  ADMIN_STATICDATA_COUPON_TAG_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        label: string
        color: string | undefined
        is_active: boolean
      }
    }
    response: { code: 200; data: Tag }
  }

  ADMIN_STATICDATA_COUPON_TAG_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_STORE_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Store }
  }

  ADMIN_STATICDATA_COUPON_STORE_LIST: {
    request: {
      header: any
      validation: {
        name: string | undefined
        type: 'wallet' | 'store' | 'bank' | 'brand' | 'event' | 'product' | 'city' | 'collection' | undefined
        is_active: boolean | undefined
        is_on_top: boolean | undefined
        is_best: boolean | undefined
        is_popular: boolean | undefined
        is_featured: boolean | undefined
        is_trending: boolean | undefined
        is_high_cashback_store: boolean | undefined
        is_frequently_used: boolean | undefined
        alphabet_char: string | undefined
        categories: number[] | undefined
        tags: number[] | undefined
        is_store_image_available: boolean | undefined
        page: number
        perPage: number
        orderBy: 'name' | 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Store> }
  }

  ADMIN_STATICDATA_COUPON_STORE_CREATE: {
    request: {
      header: any
      validation: {
        name: string
        type: 'wallet' | 'store' | 'bank' | 'brand' | 'event' | 'product' | 'city' | 'collection'
        logo_url: MultipartFileContract | undefined
        is_active: boolean
        is_on_top: boolean
        is_best: boolean
        is_popular: boolean
        is_featured: boolean
        is_trending: boolean
        is_high_cashback_store: boolean
        is_frequently_used: boolean
        terms_and_conditions: string | undefined
        rating_type: 'default' | 'strict'
        rating: number | undefined
        slug: string | undefined
        priority: number | undefined
        categories: number[]
        tags: number[] | undefined
        vendor: 'admitad' | 'trackier'
      }
    }
    response: { code: 200; data: Store }
  }

  ADMIN_STATICDATA_COUPON_STORE_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        name: string
        type: 'wallet' | 'store' | 'bank' | 'brand' | 'event' | 'product' | 'city' | 'collection'
        is_active: boolean
        logo_url: MultipartFileContract | undefined
        is_on_top: boolean
        is_best: boolean
        is_popular: boolean
        is_featured: boolean
        is_trending: boolean
        is_high_cashback_store: boolean
        is_frequently_used: boolean
        terms_and_conditions: string | undefined
        rating_type: 'default' | 'strict'
        rating: number | undefined
        slug: string | undefined
        priority: number | undefined
        categories: number[]
        tags: number[] | undefined
        vendor: 'admitad' | 'trackier'
      }
    }
    response: { code: 200; data: Store }
  }

  ADMIN_STATICDATA_COUPON_STORE_DELETE: {
    request: {
      header: any
      validation: {
        store_id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_REPORT_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Report }
  }

  ADMIN_STATICDATA_COUPON_REPORT_LIST: {
    request: {
      header: any
      validation: {
        type: 'store_review' | 'coupon_comment' | undefined
        user_id: string | undefined
        is_resolved: boolean | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Report> }
  }

  ADMIN_STATICDATA_COUPON_REPORT_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Coupon }
  }

  ADMIN_STATICDATA_COUPON_LIST: {
    request: {
      header: any
      validation: {
        store_ids: number[] | undefined
        coupon_code: string | undefined
        value_type: 'off' | 'cashback' | undefined
        is_active: boolean | undefined
        is_popular: boolean | undefined
        is_best: boolean | undefined
        is_featured: boolean | undefined
        is_trending: boolean | undefined
        is_high_cashback_store: boolean | undefined
        is_frequently_used: boolean | undefined
        is_deal_of_the_day: boolean | undefined
        is_new: boolean | undefined
        should_show_verified_time: boolean | undefined
        is_on_top: boolean | undefined
        is_for_existing_user: boolean | undefined
        more_than_success_rate: number | undefined
        categories: number[] | undefined
        tags: number[] | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: number; data: ModelPaginatorContract<Coupon> }
  }

  ADMIN_STATICDATA_COUPON_CREATE: {
    request: {
      header: any
      validation: {
        store_id: number
        coupon_code: string | undefined
        site_url: string | undefined
        is_coupon: boolean
        title: string
        is_upto: boolean
        value: number | undefined
        is_percentage: boolean
        value_type: 'off' | 'cashback'
        validity: string
        validity_date: DateTime
        description: string | undefined
        details: string[] | undefined
        is_active: boolean
        is_verified: boolean
        is_popular: boolean
        is_best: boolean
        is_trending: boolean
        is_frequently_used: boolean
        is_featured: boolean
        is_high_cashback_store: boolean
        is_deal_of_the_day: boolean
        is_new: boolean
        is_on_top: boolean
        is_for_existing_user: boolean
        should_show_verified_time: boolean
        verified_at: DateTime | undefined
        slug: string | undefined
        priority: number | undefined
        categories: number[]
        tags: number[] | undefined
        banks: number[] | undefined
      }
    }
    response: { code: number; data: Coupon }
  }

  ADMIN_STATICDATA_COUPON_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        store_id: number
        coupon_code: string | undefined
        site_url: string | undefined
        is_coupon: boolean
        title: string
        is_upto: boolean
        value: number | undefined
        is_percentage: boolean
        value_type: 'off' | 'cashback'
        validity: string
        validity_date: DateTime
        description: string | undefined
        details: string[] | undefined
        is_active: boolean
        is_verified: boolean
        is_popular: boolean
        is_best: boolean
        is_trending: boolean
        is_frequently_used: boolean
        is_featured: boolean
        is_high_cashback_store: boolean
        is_deal_of_the_day: boolean
        is_new: boolean
        is_on_top: boolean
        is_for_existing_user: boolean
        should_show_verified_time: boolean
        verified_at: DateTime | undefined
        slug: string | undefined
        priority: number | undefined
        categories: number[]
        tags: number[] | undefined
        banks: number[] | undefined
      }
    }
    response: { code: number; data: Coupon }
  }

  ADMIN_STATICDATA_COUPON_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: number; message: string }
  }

  ADMIN_STATICDATA_COUPON_COMMENT_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: CouponComment }
  }

  ADMIN_STATICDATA_COUPON_COMMENT_LIST: {
    request: {
      header: any
      validation: {
        coupon_id: number
        parent_id: number | undefined
        user_id: number | undefined
        is_visible: boolean | undefined
        search: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<CouponComment> }
  }

  ADMIN_STATICDATA_COUPON_COMMENT_VISIBLE: {
    request: {
      header: any
      validation: {
        id: number
        is_visible: boolean
      }
    }
    response: { code: number }
  }

  ADMIN_STATICDATA_COUPON_COMMENT_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_STORE_REVIEW_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: StoreReview }
  }

  ADMIN_STATICDATA_COUPON_STORE_REVIEW_LIST: {
    request: {
      header: any
      validation: {
        user_id: number | undefined
        store_id: number
        search: string | undefined
        minRating: number | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<StoreReview> }
  }

  ADMIN_STATICDATA_COUPON_STORE_REVIEW_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_STORE_REVIEW_VISIBLE: {
    request: {
      header: any
      validation: {
        id: number
        is_visible: boolean
      }
    }
    response: { code: 200; data: StoreReview }
  }

  ADMIN_STATICDATA_COUPON_BANNER_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: Banner }
  }

  ADMIN_STATICDATA_COUPON_BANNER_LIST: {
    request: {
      header: any
      validation: {
        is_active: boolean | undefined
        search: string | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Banner> }
  }

  ADMIN_STATICDATA_COUPON_BANNER_CREATE: {
    request: {
      header: any
      validation: {
        priority: number | undefined
        store_id: number | undefined
        label: string | undefined
        is_active: boolean
        logo_url: MultipartFileContract | undefined
      }
    }
    response: { code: 200; data: Banner }
  }

  ADMIN_STATICDATA_COUPON_BANNER_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        priority: number | undefined
        store_id: number | undefined
        label: string | undefined
        is_active: boolean
        logo_url: MultipartFileContract | undefined
      }
    }
    response: { code: 200; data: Banner }
  }

  ADMIN_STATICDATA_COUPON_BANNER_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_WALLET_VOUCHER_APPLY: {
    request: {
      header: any
      validation: {
        user_id: number
        code: string
      }
    }
    response: { code: 200 }
  }

  ADMIN_STATICDATA_OPERATOR_LIST: {
    request: {
      header: any
      validation: {
        biller_name: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Operator> }
  }

  ADMIN_STATICDATA_COUPON_CATEGORY_UPDATEKEYVALUE: {
    request: {
      header: any
      validation: {
        id: number
        key: 'is_active' | 'is_on_top' | 'is_popular' | 'is_featured' | 'is_trending' | 'is_frequently_used'
        value: boolean
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_UPDATEKEYVALUE: {
    request: {
      header: any
      validation: {
        id: number
        key:
          | 'is_active'
          | 'is_best'
          | 'is_on_top'
          | 'is_popular'
          | 'is_featured'
          | 'is_trending'
          | 'is_high_cashback_store'
          | 'is_frequently_used'
          | 'is_verified'
          | 'is_deal_of_the_day'
          | 'is_new'
          | 'is_for_existing_user'
        value: boolean
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_STATICDATA_COUPON_STORE_UPDATEKEYVALUE: {
    request: {
      header: any
      validation: {
        id: number
        key: 'is_active' | 'is_best' | 'is_on_top' | 'is_popular' | 'is_featured' | 'is_trending' | 'is_high_cashback_store' | 'is_frequently_used'
        value: boolean
      }
    }
    response: { code: 200; message: string }
  }
}

/**
 * URLs for usage of further development
 */
type AppUrlType = {
  [U in keyof APP_ROUTES]: {
    url: string
    headers: Object
    method: string
  }
}

export const APP_URLS: AppUrlType = {
  ADMIN_AUTH_LOGIN: {
    url: '/admin/auth/login',
    headers: {},
    method: 'POST',
  },
  ADMIN_AUTH_CHECK: {
    url: '/admin/auth/check',
    headers: {},
    method: 'POST',
  },
  ADMIN_AUTH_LOGOUT: {
    url: '/admin/auth/logout',
    headers: {},
    method: 'POST',
  },
  ADMIN_ANALYTICS_BASIC: {
    url: '/admin/analytics/basic',
    headers: {},
    method: 'POST',
  },
  ADMIN_REPORT_SALE: {
    url: '/admin/report/sale',
    headers: {},
    method: 'POST',
  },
  ADMIN_REPORT_GETPLANCOUNT: {
    url: '/admin/report/getPlanCount',
    headers: {},
    method: 'POST',
  },
  ADMIN_REPORT_GETCIRCLECOUNT: {
    url: '/admin/report/getCircleCount',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_LIST: {
    url: '/admin/ads/google/campaign/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_CREATE: {
    url: '/admin/ads/google/campaign/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_UPDATE: {
    url: '/admin/ads/google/campaign/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_DELETE: {
    url: '/admin/ads/google/campaign/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_RECHECKSTATUS: {
    url: '/admin/ads/google/campaign/recheck-status',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_ENABLE: {
    url: '/admin/ads/google/campaign/enable',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_DISABLE: {
    url: '/admin/ads/google/campaign/disable',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_LIST: {
    url: '/admin/staff/notes/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_CREATE: {
    url: '/admin/staff/notes/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_DELETE: {
    url: '/admin/staff/notes/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_UPDATE: {
    url: '/admin/staff/notes/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_LIST: {
    url: '/admin/staff/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_CREATE: {
    url: '/admin/staff/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_UPDATE: {
    url: '/admin/staff/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_DELETE: {
    url: '/admin/staff/delete',
    headers: {},
    method: 'POST',
  },

  ADMIN_USER_LIST: {
    url: '/admin/user/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_UPDATEBLOCK: {
    url: '/admin/user/updateBlock',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_UPDATEKYC: {
    url: '/admin/user/updateKyc',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_GET: {
    url: '/admin/user/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_LIST: {
    url: '/admin/user/kyc/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_LIST: {
    url: '/admin/user/kyc/full-ticket/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_UPDATE: {
    url: '/admin/user/kyc/full-ticket/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_CREATE: {
    url: '/admin/user/kyc/full-ticket/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_LIMIT_UPDATE: {
    url: '/admin/user/limit/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_PAYMENT_LIST: {
    url: '/admin/payment/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_PAYMENT_LISTSEARCHMETA: {
    url: '/admin/payment/listSearchMeta',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_GET: {
    url: '/admin/order/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_LIST: {
    url: '/admin/order/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ONHOLDPAYMENTACTION: {
    url: '/admin/order/onHoldPaymentAction',
    headers: {},
    method: 'POST',
  },

  ADMIN_ORDER_ITEM_RECHECKSINGLEITEM: {
    url: '/admin/order/item/recheckSingleItem',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ITEM_RECHECKSINGLEITEMDEBUGLOGS: {
    url: '/admin/order/item/recheckSingleItemDebugLogs',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ITEM_UPDATESINGLEITEMSTATUS: {
    url: '/admin/order/item/updateSingleItemStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_PAYMENT_RECHECKSINGLESTATUS: {
    url: '/admin/order/payment/recheckSingleStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_PAYMENT_RECHECKALLSTATUS: {
    url: '/admin/order/payment/recheckAllStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_REFUND_RECHECKSINGLESTATUS: {
    url: '/admin/order/refund/recheckSingleStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_REFUND_RECHECKALLSTATUS: {
    url: '/admin/order/refund/recheckAllStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_STATEMENT: {
    url: '/admin/wallet/statement',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_DEDUCT: {
    url: '/admin/wallet/deduct',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_LIST: {
    url: '/admin/wallet/voucher/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_CREATE: {
    url: '/admin/wallet/voucher/create',
    headers: {},
    method: 'POST',
  },

  ADMIN_STATICDATA_COUPON_CATEGORY_GET: {
    url: '/admin/static/data/coupon/category/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CATEGORY_LIST: {
    url: '/admin/static/data/coupon/category/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CATEGORY_CREATE: {
    url: '/admin/static/data/coupon/category/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CATEGORY_UPDATE: {
    url: '/admin/static/data/coupon/category/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CATEGORY_DELETE: {
    url: '/admin/static/data/coupon/category/delete',
    headers: {},
    method: 'POST',
  },

  ADMIN_STATICDATA_COUPON_BANK_GET: {
    url: '/admin/static/data/coupon/bank/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANK_LIST: {
    url: '/admin/static/data/coupon/bank/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANK_CREATE: {
    url: '/admin/static/data/coupon/bank/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANK_UPDATE: {
    url: '/admin/static/data/coupon/bank/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANK_DELETE: {
    url: '/admin/static/data/coupon/bank/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_APPLY: {
    url: '/admin/wallet/voucher/apply',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_OPERATOR_LIST: {
    url: '/admin/static-data/operator/list',
    headers: {},
    method: 'POST',
  },

  ADMIN_STATICDATA_COUPON_TAG_GET: {
    url: '/admin/static/data/coupon/tag/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_TAG_LIST: {
    url: '/admin/static/data/coupon/tag/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_TAG_CREATE: {
    url: '/admin/static/data/coupon/tag/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_TAG_UPDATE: {
    url: '/admin/static/data/coupon/tag/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_TAG_DELETE: {
    url: '/admin/static/data/coupon/tag/delete',
    headers: {},
    method: 'POST',
  },

  ADMIN_STATICDATA_COUPON_STORE_GET: {
    url: '/admin/static/data/coupon/store/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_LIST: {
    url: '/admin/static/data/coupon/store/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_CREATE: {
    url: '/admin/static/data/coupon/store/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_UPDATE: {
    url: '/admin/static/data/coupon/store/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_DELETE: {
    url: '/admin/static/data/coupon/store/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_REPORT_GET: {
    url: '/admin/static/data/coupon/report/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_REPORT_LIST: {
    url: '/admin/static/data/coupon/report/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_REPORT_DELETE: {
    url: '/admin/static/data/coupon/report/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_GET: {
    url: '/admin/static/data/coupon/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_LIST: {
    url: '/admin/static/data/coupon/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CREATE: {
    url: '/admin/static/data/coupon/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_UPDATE: {
    url: '/admin/static/data/coupon/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_DELETE: {
    url: '/admin/static/data/coupon/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_COMMENT_GET: {
    url: '/admin/static/data/coupon/comment/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_COMMENT_LIST: {
    url: '/admin/static/data/coupon/comment/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_COMMENT_VISIBLE: {
    url: '/admin/static/data/coupon/comment/visible',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_COMMENT_DELETE: {
    url: '/admin/static/data/coupon/comment/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_REVIEW_GET: {
    url: '/admin/static/data/coupon/store/review/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_REVIEW_LIST: {
    url: '/admin/static/data/coupon/store/review/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_REVIEW_DELETE: {
    url: '/admin/static/data/coupon/store/review/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_REVIEW_VISIBLE: {
    url: '/admin/static/data/coupon/store/review/visible',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_CATEGORY_UPDATEKEYVALUE: {
    url: '/admin/static/data/coupon/category/updateKeyValue',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_UPDATEKEYVALUE: {
    url: '/admin/static/data/coupon/updateKeyValue',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_STORE_UPDATEKEYVALUE: {
    url: '/admin/static/data/coupon/store/updateKeyValue',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANNER_GET: {
    url: '/admin/static/data/coupon/banner/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANNER_LIST: {
    url: '/admin/static/data/coupon/banner/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANNER_CREATE: {
    url: '/admin/static/data/coupon/banner/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANNER_UPDATE: {
    url: '/admin/static/data/coupon/banner/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUPON_BANNER_DELETE: {
    url: '/admin/static/data/coupon/banner/delete',
    headers: {},
    method: 'POST',
  },
}

export type getValidationType<T extends keyof APP_ROUTES> = ReplaceUndefinedWithNull<APP_ROUTES[T]['request']['validation']>
export type getResponseType<T extends keyof APP_ROUTES> = APP_ROUTES[T]['response']

/**
 * Request Approach
 */

export type fetchFunctionType = <T extends keyof APP_ROUTES>(
  url: string,
  headers: APP_ROUTES[T]['request']['header'],
  body: APP_ROUTES[T]['request']['validation'],
  abortSignal?: AbortSignal | undefined | null
) => Promise<APP_ROUTES[T]['response']>

export class Request {
  fn: fetchFunctionType
  constructor(fn: fetchFunctionType) {
    this.fn = fn
  }

  send<T extends keyof APP_ROUTES>(
    key: T,
    data: {
      headers?: APP_ROUTES[T]['request']['header']
      body: APP_ROUTES[T]['request']['validation']
    },
    signal?: AbortSignal | undefined | null
  ): Promise<APP_ROUTES[T]['response']> {
    return this.fn(APP_URLS[key]['url'], data.headers, data.body, signal)
  }
}

/** 
 *  Example approach
 *
  const fn: fetchFunctionType = async (url, headers, body) => {
    url
    body
    headers
    return null as any
  }
  
  const request = new Request(fn)
  request.send('TAG_TEST', { headers: {}, body: { test: 1 } }) 
*/
